import { Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { AddButtonLink } from '@/core/components';

import { ReclaimableAuthorList } from '@feature/utils/components/ReclaimableAuthorList';

import { ReclaimRequest, TechnologicalTransferReclaimSearch } from './model/TechnologicalTransferTypes';

interface PatentFoundModalProps {
  close: () => void;
  data: TechnologicalTransferReclaimSearch;

  onReclaimAuthorship: (v: ReclaimRequest) => void;
}

export function TechnologicalTransferFoundModal({ close, data, onReclaimAuthorship }: PatentFoundModalProps) {
  const { technologicalTransfer } = data;
  const { t } = useTranslation();

  return (
    <Modal
      opened
      onClose={close}
      centered
      size="lg"
      title={technologicalTransfer != null && t('patents.foundPub')}
    >
      {technologicalTransfer == null && (
        <Stack>
          <Text ta="center">{t('publications.notSearchFound')}</Text>
          <AddButtonLink
            to="../create"
            name={t('button.addNew')}
          />
        </Stack>
      )}
      {technologicalTransfer != null && (
        <Stack>
          <Text fw="500">{technologicalTransfer.title}</Text>
          <ReclaimableAuthorList
            authors={technologicalTransfer.authors}
            onReclaim={authorId => onReclaimAuthorship({ authorId, technologicalTransferId: technologicalTransfer.id })}
          />
        </Stack>
      )}
    </Modal>
  );
}
